var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSewerObjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main-navigation-Icons/Active/Segments",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Active-Section/Collapsed-side-menu"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.5,
    className: "svg-path1",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Selector",
    className: "svg-path2",
    fillOpacity: 0.8,
    points: "0 0 6 0 6 50 0 50"
  })), /*#__PURE__*/React.createElement("path", {
    className: "svg-path3",
    fillOpacity: 0.8,
    d: "M16.5384615,21 L16.538,21.019 L18.076,21.019 L18.0769231,21 L19.6153846,21 L19.615,22.32 L30.384,22.32 L30.3846154,21 L35,21 L34.999,27.401 L35,27.401738 L35,28.6723589 L34.999,28.672 L35,28.6923077 L33.4615385,28.6923077 L33.461,28.672 L31.923,28.672 L31.9230769,28.6923077 L30.3846154,28.6923077 L30.384,27.372 L19.615,27.372 L19.6153846,28.6923077 L15,28.6923077 L15,21 L16.5384615,21 Z M18.076,22.29 L16.538,22.29 L16.538,27.421 L18.076,27.421 L18.076,22.29 Z M33.461,22.27 L31.923,22.27 L31.923,27.401 L33.461,27.401 L33.461,22.27 Z M30.384,23.59 L19.615,23.59 L19.615,26.101 L30.384,26.101 L30.384,23.59 Z",
    id: "Segment"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSewerObjects);
export default __webpack_public_path__ + "static/media/sewer-objects.58344409c1c1b1baf22a340e0bf5aebb.svg";
export { ForwardRef as ReactComponent };